/*-----------------------------------------------------------------
- Fields translations
-----------------------------------------------------------------*/
export default {
};
